import { ArrowUpRight } from "lucide-react";
import type { translations } from "../../i18n";

type ProofT = (typeof translations)["de"]["proof"];

const CLIENT_LOGOS = [
  { src: "/clients/list.png", alt: "LIST Gruppe", href: "https://www.list-gruppe.de", h: "h-8 sm:h-9" },
  { src: "/clients/geiger.svg", alt: "Geiger Gruppe", href: "https://www.geigergruppe.de", h: "h-6 sm:h-7" },
  { src: "/clients/h4a.png", alt: "h4a Architekten", href: "https://www.h4a-architekten.de", h: "h-7 sm:h-8" },
  { src: "/clients/saits.svg", alt: "SAITS", href: "https://saits.ai", h: "h-5 sm:h-6" },
];

const PRESS_URL =
  "https://www.immobilienmanager.de/wer-auf-die-ausschreibung-wartet-ist-zu-spaet-30092026";

const LABEL = "text-[11px] sm:text-xs font-bold uppercase tracking-[0.1em] text-slate-500";
const LOGO_LINK = "group inline-flex";
const LOGO_IMG = "w-auto grayscale opacity-70 transition group-hover:grayscale-0 group-hover:opacity-100";

export function PressLogo({ t, align = "center" }: { t: ProofT; align?: "center" | "start" }) {
  return (
    <div className={`flex flex-col gap-3 ${align === "center" ? "items-center" : "items-start"}`}>
      <p className={LABEL}>{t.pressLabel}</p>
      <a
        href={PRESS_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Immobilien Manager – Artikel lesen"
        className={`${LOGO_LINK} items-start gap-1`}
      >
        <img
          src="/press/immobilienmanager.svg"
          alt="Immobilien Manager"
          loading="lazy"
          className={`h-7 sm:h-9 ${LOGO_IMG}`}
        />
        <ArrowUpRight
          aria-hidden
          className="w-4 h-4 sm:w-5 sm:h-5 text-slate-400 transition group-hover:text-orange-600 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
        />
      </a>
    </div>
  );
}

export default function ProofStrip({ t }: { t: ProofT }) {
  return (
    <section className="bg-white px-5 sm:px-6 py-8 sm:py-10 border-y border-slate-200">
      <div className="max-w-[1100px] mx-auto">
        <PressLogo t={t} />
        <p className={`${LABEL} text-center mt-8 sm:mt-9`}>{t.clientsLabel}</p>
        <ul className="mt-5 grid grid-cols-2 sm:grid-cols-4 items-center justify-items-center gap-x-6 gap-y-6">
          {CLIENT_LOGOS.map((logo) => (
            <li key={logo.src}>
              <a
                href={logo.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={logo.alt}
                className={LOGO_LINK}
              >
                <img src={logo.src} alt={logo.alt} loading="lazy" className={`${logo.h} ${LOGO_IMG}`} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
